/**
 * 寬度 ≤768px 就是手機版面（與 console-ui styles.css、@tpte/ui AppShell 的 md 斷點一致）。
 *
 * 只回一個 boolean，不碰 DOM 版面；外殼由 AppShell 決定（<768px 沒有側欄、改底部列）。
 */
import { useEffect, useState } from 'react';

export function useIsNarrow(maxWidth = 768): boolean {
  const query = `(max-width: ${maxWidth}px)`;
  const [narrow, setNarrow] = useState(
    () => typeof window !== 'undefined' && window.matchMedia(query).matches,
  );

  useEffect(() => {
    const mq = window.matchMedia(`(max-width: ${maxWidth}px)`);
    const onChange = () => setNarrow(mq.matches);
    onChange();
    mq.addEventListener('change', onChange);
    return () => mq.removeEventListener('change', onChange);
  }, [maxWidth]);

  return narrow;
}
